import { Injectable } from '@angular/core';
import {DxRequestOptions} from "../../dx-core/domain/http/dx-request-options";
import {HttpHeaders, HttpParams, HttpResponse} from "@angular/common/http";
import {BdpkConfigService} from "../../bdpk-common/services/bdpk-config.service";
import {DxObjectMapper} from "../../dx-core/services/dx-object-mapper.service";
import {DxHttpDispatcher} from "../../dx-core/services/dx-http-dispatcher.service";
import {Observable} from "rxjs";
import {PitAgreementTask} from "../../pit-agreement/domain/pit-agreement-task";
import {map, take} from "rxjs/operators";
import {PitUser} from "../domain/pit-user";

/**
 *  Service corresponding with users-service server endpoint
 */
@Injectable({
  providedIn: 'root'
})
export class PitUsersService {

  private usContext: string;
  private usOptions: DxRequestOptions = {
    headers: new HttpHeaders().set('Content-Type', 'application/json;charset=utf-8'),
    observe: "response"
  };

  constructor (private _configService: BdpkConfigService,
               private _mapper: DxObjectMapper,
               private _http: DxHttpDispatcher) {
    this.usContext = this._configService.pitBackendUsersEndPoint;
  }

  getUsers(showLocked: boolean = false): Observable<PitUser[]> {

    return this._http.get(`${this.usContext}/`, {...this.usOptions,
                          params: new HttpParams().append('showLocked', String(showLocked))} as DxRequestOptions)
                     .pipe(take(1),
                           map((response: HttpResponse<any>) => {
                              return this._mapper.deserializeASArray<PitUser>(response.body, PitUser);
    }));
  }
}
